export enum requestAttachmentStatusEnum {
    ANULADO = 0
}